module.exports = __webpack_public_path__ + "img/mryx@2X.1e342ec9.png";